import { render, staticRenderFns } from "./ReferenceImage.vue?vue&type=template&id=6173fabd&scoped=true&"
import script from "./ReferenceImage.vue?vue&type=script&lang=js&"
export * from "./ReferenceImage.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceImage.vue?vue&type=style&index=0&id=6173fabd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173fabd",
  null
  
)

export default component.exports